<script setup lang="ts">
import type { MandatoryInfoItem } from '../../types'

defineProps<{
  criteria: MandatoryInfoItem[]
}>()
</script>

<template>
  <div v-if="criteria.length > 0" class="mandatory-info">
    <table class="mandatory-info__table">
      <tbody>
        <tr v-for="(c, i) in criteria" :key="i">
          <td class="mandatory-info__label">{{ c.description }}</td>
          <td class="mandatory-info__value">
            {{ c.value }}<template v-if="c.unit"> {{ c.unit }}</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
.mandatory-info {
  margin-top: 0.75rem;

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;

    td {
      padding: 4px 8px;
      border-bottom: 1px solid #f3f4f6;
    }
  }

  &__label {
    color: #666;
    width: 45%;
  }

  &__value {
    font-weight: 500;
  }
}
</style>
